/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetProjectsProjectidOptions, GetProjectsProjectidStatus200, GetProjectsProjectidStatus401, GetProjectsProjectidStatus404, GetProjectsProjectidStatus500 } from '../types/GetProjectsProjectid'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getProjectsProjectid } from '../clients/getProjectsProjectid'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getProjectsProjectidQueryKey = ({ path }: Omit<GetProjectsProjectidOptions, 'headers'>) => [{ url: '/projects/:projectId', params: path }] as const

type GetProjectsProjectidQueryKey = ReturnType<typeof getProjectsProjectidQueryKey>

export function getProjectsProjectidQueryOptions({ path }: GetProjectsProjectidOptions, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getProjectsProjectidQueryKey({ path })
  return queryOptions<GetProjectsProjectidStatus200, ResponseErrorConfig<GetProjectsProjectidStatus401 | GetProjectsProjectidStatus404 | GetProjectsProjectidStatus500>, GetProjectsProjectidStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return getProjectsProjectid({ ...config, path, signal: config.signal ?? signal, throwOnError: true }).unwrap()
   },
  })
}

/**
 * {@link /projects/:projectId}
 */
export function useGetProjectsProjectid<TData = GetProjectsProjectidStatus200, TQueryData = GetProjectsProjectidStatus200, TQueryKey extends QueryKey = GetProjectsProjectidQueryKey>({ path }: { path: GetProjectsProjectidOptions['path'] | (() => GetProjectsProjectidOptions['path']) }, options: {
  query?: Partial<QueryObserverOptions<GetProjectsProjectidStatus200, ResponseErrorConfig<GetProjectsProjectidStatus401 | GetProjectsProjectidStatus404 | GetProjectsProjectidStatus500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getProjectsProjectidQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...getProjectsProjectidQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetProjectsProjectidStatus401 | GetProjectsProjectidStatus404 | GetProjectsProjectidStatus500>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
